const divConfirmCreateUser = {
  text: 'Account created successfully',
  link: 'Expired link'
};

export default divConfirmCreateUser;
